import { call, put, takeEvery } from 'redux-saga/effects';
import { coOpActionCreators, CoOpActionKeys, FetchCoOpDealerEstimates, ICoOpDealerEstimate } from '..';
import { uiActionCreators } from '../../ui';
import * as api from '../coOpApi';

function* fetchCoOpDealerEstimatesSaga(action: FetchCoOpDealerEstimates) {
  yield put(uiActionCreators.toggleLoading('coOpDealerEstimate'));
  const response: ICoOpDealerEstimate[] = yield call(
    api.fetchCoOpDealerEstiamte,
    action.payload.businessEntityId,
    action.payload.fiscalYear
  );

  yield put(coOpActionCreators.setDealerEstimates(response));
  yield put(uiActionCreators.toggleLoading('coOpDealerEstimate'));
}

export function* watchFetchCoOpDealerEstimates() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_DEALER_ESTIMATES, fetchCoOpDealerEstimatesSaga);
}
